module.exports = __webpack_public_path__ + "images/icons/icon-ribbon-fail-f913132d.svg";